import { makeStyles, lighten } from '@material-ui/core';
import { _ as __assign } from './_tslib-ff3a08af.js';
import React, { useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
import { s as styleConstants } from './constants-3b80be2a.js';

var StylesConstantsContext = React.createContext(styleConstants);
var StyleConstantsProvider = function (_a) {
    var children = _a.children,
        constants = _a.constants;
    return jsx(StylesConstantsContext.Provider, { value: constants, children: children });
};
var StyleConstantsConsumer = StylesConstantsContext.Consumer;

function useStyleConstants() {
    return useContext(StylesConstantsContext);
}
function useStylesWithConstants(stylesCreator, additionalProps) {
    var constants = useStyleConstants();
    return stylesCreator(__assign(__assign({}, constants), additionalProps));
}

var styles = makeStyles(function () {
    return {
        btn: {
            alignItems: 'center',
            borderRadius: '5px',
            cursor: 'pointer',
            display: 'flex',
            fontSize: '13px',
            justifyContent: 'center',
            fontWeight: 600,
            height: '36px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textTransform: 'none'
        },
        active: {
            border: function (constants) {
                return "3px solid ".concat(constants.colors.primaryColor);
            },
            color: function (constants) {
                return constants.colors.primaryColor;
            },
            padding: '0 17px'
        },
        inactive: {
            backgroundColor: function (constants) {
                return constants.colors.grey2;
            },
            color: '#596379',
            padding: '0 20px'
        },
        filled: {
            backgroundColor: function (constants) {
                return constants.colors.primaryColor;
            },
            color: 'white',
            '&:hover': {
                backgroundColor: function (constants) {
                    return lighten(constants.colors.primaryColor, 0.2);
                }
            }
        },
        filledGrey: {
            backgroundColor: '#929394',
            color: 'white'
        }
    };
});
var globalButtonStyles = function () {
    return useStylesWithConstants(styles);
};

export { StylesConstantsContext as S, StyleConstantsConsumer as a, StyleConstantsProvider as b, useStylesWithConstants as c, globalButtonStyles as g, useStyleConstants as u };
